<template>
    <div :class="[$style['mds-alert'], classObject, sizeClass, variationClass]" :data-mds-version="version">
        <div :class="$style['mds-alert__variation']">
            <mds-icon :name="variationIcon" :class="$style['mds-alert__icon']" :size="iconSize" />
        </div>
        <div :class="$style['mds-alert__body']">
            <div :class="$style['mds-alert__content']">
                <div v-if="title" :class="$style['mds-alert__title']">{{ title }}</div>
                <p :class="$style['mds-alert__message']">
                    <slot>{{ text }}</slot>
                </p>
                <ul v-if="list" :class="$style['mds-alert__list']">
                    <li v-for="(item, index) in list" :key="index" :class="$style['mds-alert__list-item']">
                        {{ item }}
                    </li>
                </ul>
                <slot name="mds-alert-custom-action"></slot>
            </div>
        </div>
        <mds-button
            v-if="!persistent"
            :class="$style['mds-alert__dismiss-button']"
            size="small"
            icon="remove"
            variation="icon-only"
            :text="dismissIconAriaLabel"
            @click="$emit('mds-alert-dismissed', $event.target)"
        />
    </div>
</template>

<script>
    import MdsIcon from '@mds/icon';
    import { MdsButton } from '@mds/button';

    // Import component's API
    import MdsAlertProps from './alert_props.js';

    export default {
        name: 'MdsAlert',
        components: {
            MdsIcon,
            MdsButton,
        },
        props: MdsAlertProps,
        computed: {
            classObject() {
                const obj = {};
                obj[this.$style['mds-alert--tinted']] = this.tinted && this.variation !== 'informational';
                obj[this.$style['mds-alert--dismissible']] = !this.persistent;

                return obj;
            },
            sizeClass() {
                return this.$style[`mds-alert--${this.size}`];
            },
            iconSize() {
                return this.size === 'small' ? 'small' : 'medium';
            },
            variationClass() {
                return this.$style[`mds-alert--${this.variation}`];
            },
            variationIcon() {
                const icon = {
                    error: 'alert',
                    warning: 'alert',
                    success: 'check',
                    informational: 'info-circle',
                };

                return icon[this.variation];
            },
        },
    };
</script>

<style lang="scss" module>
    @import './alert.scss';
</style>
